<section class="final-cta-section py-5">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left side: Main CTA content -->
      <div class="col-lg-6 col-md-12">
        <div class="cta-content">
          <h2 class="cta-title">Ready for one cleaner operating layer?</h2>
          <p class="cta-description">Start a 90-day free trial (up to 50 active members) and run members, events, dues, and reporting in one place—or watch the walkthrough first if you want the full picture. A card is required at signup; you won't be charged today.</p>
        </div>
      </div>
      
      <!-- Right side: CTA actions -->
      <div class="col-lg-6 col-md-12">
        <div class="cta-actions">
          <button mat-flat-button color="primary" routerLink="/register-organization" class="cta-button me-2">Start free trial</button>
          <a mat-stroked-button color="primary" routerLink="/" fragment="see-how-it-works" class="cta-button">See how it works</a>
        </div>
      </div>
    </div>
  </div>
</section>
